import { render, staticRenderFns } from "./PorterageENumber.vue?vue&type=template&id=4feb78c4"
import script from "./PorterageENumber.vue?vue&type=script&lang=js"
export * from "./PorterageENumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports